import React, { useEffect, useMemo, useState } from 'react'

function readMeta(name) {
  const el = document.querySelector(`meta[name="${name}"]`)
  return el ? el.content : ''
}

export default function MaintenanceGate({ children }) {
  const endpoint = useMemo(() => readMeta('license-endpoint'), [])
  const siteId = useMemo(() => readMeta('alriche'), [])
  const maintenanceText = useMemo(() => readMeta('maintenance-message') || 'Проверьте подключение к интернету.', [])

  const [active, setActive] = useState(true)
  const [checked, setChecked] = useState(false)

  useEffect(() => {
    // In development, skip remote checks to avoid blocking UI when /api is not proxied
    if (typeof process !== 'undefined' && process.env && process.env.NODE_ENV === 'development') {
      setActive(true)
      setChecked(true)
      return
    }

    let mounted = true
    if (!endpoint || !siteId) {
      setChecked(true)
      return
    }

    const check = async () => {
      try {
        const url = `${endpoint}${endpoint.includes('?') ? '&' : '?'}siteId=${encodeURIComponent(siteId)}`
        const r = await fetch(url, { credentials: 'omit', cache: 'no-store' })
        if (!mounted) return
        if (r.ok) {
          const j = await r.json()
          setActive(Boolean(j && j.active))
        } else {
          setActive(false)
        }
      } catch (_) {
        if (mounted) setActive(false)
      } finally {
        if (mounted) setChecked(true)
      }
    }

    check()
    const id = setInterval(check, 60000)
    return () => { mounted = false; clearInterval(id) }
  }, [endpoint, siteId])

  if (!checked) return null
  if (!active) {
    return (
      <div style={{ minHeight: '100vh', background: '#0a0a0a', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ maxWidth: 720, padding: 24, textAlign: 'center' }}>
          <div style={{ fontFamily: 'Playfair Display,serif', fontSize: 28, letterSpacing: '0.06em', marginBottom: 12 }}>ALRICHE</div>
          <div style={{ opacity: 0.8, fontSize: 16, lineHeight: 1.6 }}>{maintenanceText}</div>
        </div>
      </div>
    )
  }

  return <>{children}</>
}
